import React from 'react'

export default function PageModal({children}:any) {
  return <div className="modalOverlay">{children}</div>;
}
